import { add, format } from 'date-fns';

import { PolicyHeader, PolicyTransactionInformation } from '../../types/policy';
import { DateFormat } from '../../utils';

export const getPolicyHeader = ({
  coverStartFormatted,
  quoteNumber,
}: {
  coverStartFormatted: string;
  quoteNumber?: string | null;
}): PolicyHeader => {
  /* All credit card info exists OR All bank account info exists */
  const coverExpiryDateFormatted =
    coverStartFormatted &&
    format(
      add(new Date(coverStartFormatted), {
        years: 1,
      }),
      DateFormat.yyyyMMdd
    );
  const policyTransactionInformation: PolicyTransactionInformation = {
    inceptionDate: coverStartFormatted,
    effectiveDate: coverStartFormatted,
    /** @todo MS to make a separate quoteNumber field instead of re-using policyNumber */
    ...(quoteNumber && { policyNumber: quoteNumber }),
    expiryDate: coverExpiryDateFormatted ?? '',
  };

  return {
    policyTransactionInformation: {
      ...policyTransactionInformation,
      product: 'BPK',
    },
  };
};
